import type { PropsWithChildren } from 'react';
import { cn } from '@/utils/cn';

interface BadgeProps {
  tone?: 'default' | 'success' | 'warning' | 'danger' | 'info';
}

export function Badge({ children, tone = 'default' }: PropsWithChildren<BadgeProps>): JSX.Element {
  return <span className={cn('badge', `badge--${tone}`)}>{children}</span>;
}

